<template>
  <er-card v-loading="loading" class="st-status-graph">
    <el-row slot="header">
      <layout-toolbar justify="start" align="center">
        <p class="card-title">
          {{ `${$t("Comn_shrimptalk")} ${$t("Comn_hourly_feed")}` }}
        </p>
        <el-col :span="3">
          <er-select
            :key="pondId"
            v-model="selectStId"
            @change="handleChangeInSt"
            size="mini"
            :placeholder="$t('Comn_select_shrimptalks')"
          >
            <!-- v-if="listPondGuards>1" -->
            <el-option
              v-for="st in listShrimpTalks"
              :key="st.code"
              :value="st._id"
              :label="st.title || stTitle(st.code)"
            ></el-option>
          </er-select>
        </el-col>
        <el-date-picker
          class="date-picker-wrapper"
          size="mini"
          type="date"
          :format="$commonUtils.DATE_OBJ_DATE_FORMAT_WITH_YEAR"
          v-model="dateRange[1]"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="handleValueChange"
        ></el-date-picker>
      </layout-toolbar>
    </el-row>
    <el-row :key="$i18n.locale">
      <high-charts
        :options="chartOptions"
        ref="highcharts"
        constructor-type="stockChart"
      ></high-charts>
    </el-row>
  </er-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import errorHandlerMixin from "@/mixins/errorHandlerMixin";
import chartMixin from "@/mixins/chartMixin";
import { stGraphConfig } from "./chartOptions";
import ShrimpTalk from "@/model/shrimptalk";
import { castISOStringToUserTZ } from "@/utils/commonUtils";

export default {
  mixins: [errorHandlerMixin, chartMixin],
  data: function() {
    return {
      feed_hourly_logs: [],
      dataViewOptions: "Raw Data",
      dateRange: [],
      params: {
        from_date: "",
        to_date: "",
        month_of: null,
        week_of: null
      },
      chartOptions: { ...stGraphConfig },
      loading: false,
      selectStId: "",
      listShrimpTalks: [],
      groupByStsId: {},
      STResponseData: []
    };
  },
  computed: {
    ...mapGetters("pondDetails", {
      getStHourlyFeedGraph: "getStHourlyFeedGraph",
      getStResponseGraphData: "getStResponseGraphData",
      getSTGraphHourlyIntakeResponseData: "getSTGraphHourlyIntakeResponseData"
    }),
    ...mapGetters("user", {
      getMomentObjectUserTZ: "getMomentObjectUserTZ",
      getUserTimeZoneOffset: "getUserTimeZoneOffset"
    }),
    dataViewOptionsStr() {
      return {
        "Raw Data": "Pond_raw_data",
        "Average Data": "Comn_avrg_data"
      };
    },
    defaultMomentDtRangeForCurrCulture() {
      return [
        this.getMomentObjectUserTZ()
          .subtract(3, "days")
          .startOf("days"),
        this.getMomentObjectUserTZ()
      ];
    },
    pickerOptions() {
      return {
        disabledDate: this.disableDateMethod
      };
    },
    stTitle() {
      return code => {
        return ShrimpTalk.v1Title(code);
      };
    }
  },
  methods: {
    ...mapActions("pondDetails", {
      fetchHourWisePondFeed: "fetchHourWisePondFeed",
      fetchStStatsData: "fetchStStatsData"
    }),
    async initComponent() {
      this.loading = true;
      try {
        const shrimp_talks = this.getSelectedPond.shrimp_talks || [];
        if (shrimp_talks.length > 0) {
          this.listShrimpTalks = this.$lodash
            .cloneDeep(shrimp_talks)
            .sort((a, b) =>
              this.$commonUtils.alphaNumericComparator(a.title, b.title)
            );
          const stIds = shrimp_talks.map(st => st._id);
          if (
            (!this.selectStId && this.selectStId === "") ||
            stIds.indexOf(this.selectStId) === -1
          ) {
            this.selectStId = this.listShrimpTalks[0]._id;
          }
          console.log(this.selectStId);
          await this.fetchHourWisePondFeed({
            deviceType: "shrimp_talk",
            params: this.params
          });
          this.feed_hourly_logs = this.getStHourlyFeedGraph || [];
          await this.fetchStConfigData(this.selectStId);
          this.initAxisTextKeys("Comn_date_and_time", [
            "PM_dispensed_feed_kg",
            "Comn_response"
          ]);
        } else {
          this.feed_hourly_logs = [];
          this.selectStId = "";
          this.listShrimpTalks = [];
        }
        this.initChartLang();
      } catch (err) {
        this.errorMessages(err, true);
      } finally {
        this.loading = false;
      }
    },
    parseStStatsData(stStatsData, dateRange) {
      const isoString = castISOStringToUserTZ(
        dateRange[1] + "T00:00:00.000Z",
        this.getUserTimeZoneOffset
      );
      const totalDayKeys = [];
      for (let hour = 0; hour < 24; hour++) {
        const correctDate = this.$moment(isoString).startOf("day");
        const eachHour = correctDate.add(hour, "hours").valueOf();
        totalDayKeys.push(eachHour);
      }
      this.STResponseData = totalDayKeys.map(x => {
        if (stStatsData[x]) {
          return [x, stStatsData[x]];
        }
        return [x, 0];
      });
    },
    setAxisText() {
      this.chartOptions.xAxis.title.text = this.$t(this.xAxisTextKey);
      this.chartOptions.yAxis[0].title.text = this.$t(this.yAxisTextKey[0]);
      this.chartOptions.yAxis[1].title.text = this.$t(this.yAxisTextKey[1]);
    },
    pondHourlyFeed(pondFeedDaysWise = [], dateRange) {
      const dayFeedAutomatic = {};
      pondFeedDaysWise.forEach(dayFeed => {
        const isoString = castISOStringToUserTZ(
          dayFeed.date,
          this.getUserTimeZoneOffset
        );
        const availableSTIds = new Set();
        const totalDayKeys = [];
        for (let hour = 0; hour < 24; hour++) {
          const correctDate = this.$moment(isoString).startOf("day");
          const dateTimeFeed = correctDate.add(hour, "hours").valueOf();
          totalDayKeys.push(dateTimeFeed);
        }
        dayFeed.time_slots.forEach(timeSlotFeed => {
          const correctDate = this.$moment(isoString).startOf("day");
          const dateTimeFeed = correctDate
            .add(timeSlotFeed.s_time_in_seconds, "seconds")
            .valueOf();
          dayFeedAutomatic[dateTimeFeed] = timeSlotFeed.pond_mothers.reduce(
            (acc, pm) => {
              if (pm.mode === "AUTOMATIC") {
                const stId = pm.shrimp_talk_id;
                availableSTIds.add(stId);
                if (acc[stId] === undefined) {
                  acc[stId] = 0;
                }
                acc[stId] += pm.dispensed_feed;
              }
              return acc;
            },
            {}
          );
          totalDayKeys.forEach(dayKey => {
            if (!dayFeedAutomatic[dayKey]) {
              dayFeedAutomatic[dayKey] = {};
            }
            availableSTIds.forEach(stId => {
              if (!dayFeedAutomatic[dayKey][stId]) {
                dayFeedAutomatic[dayKey][stId] = undefined;
              }
            });
          });
        });
      });
      const groupBySts = {};
      Object.keys(dayFeedAutomatic).forEach(key => {
        const stIds = Object.keys(dayFeedAutomatic[key]);
        stIds.forEach(stId => {
          if (typeof groupBySts[stId] === "undefined") {
            groupBySts[stId] = [];
          }
          groupBySts[stId].push({
            x: Number(key),
            y: dayFeedAutomatic[key][stId]
          });
        });
      });
      Object.keys(groupBySts).map(key => {
        groupBySts[key].sort((a, b) => a.x - b.x);
      });
      this.groupByStsId = groupBySts;
    },
    handleValueChange: function(currentSelectedValues) {
      let value = Array.isArray(currentSelectedValues)
        ? currentSelectedValues[1]
        : currentSelectedValues;
      value = this.$moment(value, "YYYY-MM-DD");
      const beforeStartOfCulture = value.isBefore(
        this.getMomentObjArrOfCultureDateRange[0],
        "days"
      );
      const afterEndOfCulture = value.isAfter(
        this.getMomentObjArrOfCultureDateRange[1],
        "days"
      );
      if (beforeStartOfCulture) {
        value = this.getMomentObjArrOfCultureDateRange[0];
      } else if (afterEndOfCulture) {
        value = this.getMomentObjArrOfCultureDateRange[1];
      }
      this.params.from_date = value.format("YYYY-MM-DD");
      this.params.to_date = value.format("YYYY-MM-DD");
      this.initComponent();
    },
    handleChangeInSt: async function(stId) {
      if (this.groupByStsId[stId]) {
        await this.fetchStConfigData(stId);
        this.initChartSeries(
          this.groupByStsId[stId] || [],
          this.getSTGraphHourlyIntakeResponseData || []
        );
      } else {
        this.initChartSeries([], []);
      }
    },
    async fetchStConfigData(stId) {
      const params = { ...this.params };
      params.from_date += "T00:00:00.000Z";
      params.to_date += "T23:59:59.999Z";
      await this.fetchStStatsData({ stId, params, graph: "ST_HOURLY" });
    },
    generateData() {
      const schedulePMsFeed = [];
      const automaticPMsFeed = [];
      const startDate = this.$moment(this.dateRange[0]);
      const timeGap = 1000;
      for (let i = 0; i < timeGap; i++) {
        schedulePMsFeed.push({
          x: startDate.add(i, "minutes").toDate(),
          y: Math.random() * 100
        });
        automaticPMsFeed.push({
          x: startDate.add(i, "minutes").toDate(),
          y: Math.random() * 100
        });
      }
      return { automaticPMsFeed, schedulePMsFeed };
    },
    initChart() {
      let stFeedData = [];
      let stResponseData = [];
      if (
        this.feed_hourly_logs.length === 0 ||
        (this.getStResponseGraphData || []).length === 0
      ) {
        this.chartOptions.series = [];
        return;
      }
      this.pondHourlyFeed(
        this.feed_hourly_logs,
        this.dateRange,
        this.selectStId
      );
      this.parseStStatsData(
        this.getSTGraphHourlyIntakeResponseData,
        this.dateRange
      );
      stFeedData = this.groupByStsId[this.selectStId] || [];
      stResponseData = this.STResponseData || [];
      this.initChartSeries(stFeedData, stResponseData);
    },
    initChartSeries(stFeedData, hourlyIntakeResponse) {
      this.chartOptions.series = [];
      if (stFeedData.length > 0) {
        this.chartOptions.series.push({
          name: this.$t("Comn_hourly_feed"),
          data: stFeedData,
          color: "#758e32",
          type: "column",
          pointWidth: 10,
          yAxis: 0,
          dataGrouping: {
            enabled: false
          },
          visible: true
        });
      }
      if (hourlyIntakeResponse.length > 0) {
        this.chartOptions.series.push({
          name: this.$t("Comn_feeding_response"),
          type: "spline",
          yAxis: 1,
          data: hourlyIntakeResponse,
          tooltip: {
            valueSuffix: " "
          },
          color: "#7394cb",
          dataGrouping: {
            enabled: false
          },
          visible: true
        });
      }
    }
  }
};
</script>
<style lang="scss">
.st-status-graph {
  .el-card__header .date-picker-wrapper {
    margin-left: auto;
    @include responsiveProperty(width, 110px, 110px, 140px);
  }
  .el-select .el-input__inner {
    cursor: pointer;
    margin-right: 15px;
    padding-right: 35px;
  }

  .el-input--suffix .el-input__inner {
    padding-right: 18px;
    text-align: center;
  }
}
</style>
